/*
 * Cache - Null Reference Fixes
 * ============================================================
 * Patches three null-reference JS errors identified via Microsoft Clarity
 * that affect 4-10% of sessions each on trustcache.com.
 *
 * Errors fixed:
 *   1. comparePriceText.classList
 *      Pipeline variant handler calls [data-compare-text].classList without
 *      null check. Element only renders when product has compare-at price.
 *
 *   2. close.addEventListener
 *      SearchPopdown needs [data-close-popdown].
 *      GDPR/newsletter popups need [data-close-modal].
 *      If either is missing the whole component crashes on init.
 *
 *   3. outerWrapper.querySelector
 *      Pipeline ProductForm resolves outerWrapper as nearest
 *      [data-section-id] or [data-quickview-modal] ancestor.
 *      In cart upsell or recommendation widgets outside both, outerWrapper
 *      is null and all queries crash.
 *
 * Cart flicker fix:
 *   The MutationObserver is disconnected before any DOM patching and
 *   reconnected after. This prevents our phantom-element injections from
 *   triggering additional observer callbacks, which was causing cascading
 *   DOM writes that interfered with Pipeline's cart drawer animation.
 */

(function () {
  'use strict';

  // Attribute stamped on every element we inject so we never re-process them.
  var PHANTOM_ATTR = 'data-cache-phantom';

  function ensureComparePriceElements(root) {
    root = root || document;
    root.querySelectorAll('[data-compare-price]').forEach(function (el) {
      if (el.hasAttribute(PHANTOM_ATTR)) return;
      var wrapper = el.parentElement;
      if (wrapper && !wrapper.querySelector('[data-compare-text]')) {
        wrapper.appendChild(phantom('span', 'data-compare-text'));
      }
    });
    root.querySelectorAll('[data-form-holder]').forEach(function (holder) {
      if (holder.hasAttribute(PHANTOM_ATTR)) return;
      if (!holder.querySelector('[data-compare-price]')) {
        holder.appendChild(phantom('span', 'data-compare-price'));
      }
      if (!holder.querySelector('[data-compare-text]')) {
        holder.appendChild(phantom('span', 'data-compare-text'));
      }
    });
  }

  function ensureCloseButtons(root) {
    root = root || document;
    root.querySelectorAll('[data-search-popdown-wrap]').forEach(function (el) {
      if (!el.querySelector('[data-close-popdown]')) {
        el.appendChild(phantomBtn('data-close-popdown'));
      }
    });
    root.querySelectorAll('[data-product-add-popdown-wrapper]').forEach(function (el) {
      if (!el.querySelector('[data-close-popdown]')) {
        el.appendChild(phantomBtn('data-close-popdown'));
      }
    });
    root.querySelectorAll('[data-tracking-consent], [data-newsletter-section]').forEach(function (el) {
      if (!el.querySelector('[data-close-modal]')) {
        el.appendChild(phantomBtn('data-close-modal'));
      }
    });
  }

  function ensureOuterWrapper(root) {
    root = root || document;
    root.querySelectorAll('[data-product-form]').forEach(function (form) {
      if (form.hasAttribute(PHANTOM_ATTR)) return;
      // Don't restructure forms inside the cart drawer — Pipeline manages
      // those DOM references actively and restructuring causes the flicker.
      if (
        form.closest('[data-cart-drawer]') ||
        form.closest('[data-cart-items]') ||
        form.closest('[data-cart]') ||
        form.closest('[data-ajax-cart]')
      ) return;
      var hasWrapper =
        form.closest('[data-section-id]') ||
        form.closest('[data-quickview-modal]');
      if (!hasWrapper) {
        var wrap = document.createElement('div');
        wrap.setAttribute('data-section-id', 'cache-patch-' + Math.random().toString(36).slice(2));
        wrap.setAttribute(PHANTOM_ATTR, '1');
        form.parentNode.insertBefore(wrap, form);
        wrap.appendChild(form);
      }
    });
  }

  function phantom(tag, attr) {
    var el = document.createElement(tag);
    el.setAttribute(attr, '');
    el.setAttribute(PHANTOM_ATTR, '1');
    el.style.cssText = 'display:none!important;position:absolute;visibility:hidden;pointer-events:none;';
    el.setAttribute('aria-hidden', 'true');
    return el;
  }

  function phantomBtn(attr) {
    var btn = document.createElement('button');
    btn.setAttribute(attr, '');
    btn.setAttribute(PHANTOM_ATTR, '1');
    btn.type = 'button';
    btn.style.cssText = 'display:none!important;position:absolute;visibility:hidden;pointer-events:none;';
    btn.setAttribute('aria-hidden', 'true');
    btn.setAttribute('tabindex', '-1');
    return btn;
  }

  function applyAllFixes(root) {
    ensureComparePriceElements(root);
    ensureCloseButtons(root);
    ensureOuterWrapper(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyAllFixes(document);
    });
  } else {
    applyAllFixes(document);
  }

  if (window.MutationObserver) {
    var patchObserver = new MutationObserver(function (mutations) {
      // Disconnect BEFORE touching the DOM so our own injections don't
      // re-trigger this callback (which was causing cascading mutations
      // and interfering with Pipeline's cart drawer open animation).
      patchObserver.disconnect();

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          // Skip text nodes and any element we injected ourselves.
          if (node.nodeType !== 1) return;
          if (node.hasAttribute && node.hasAttribute(PHANTOM_ATTR)) return;
          applyAllFixes(node);
        });
      });

      // Reconnect after all patching is done.
      patchObserver.observe(document.body, { childList: true, subtree: true });
    });

    if (document.body) {
      patchObserver.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        patchObserver.observe(document.body, { childList: true, subtree: true });
      });
    }
  }

})();
